<script lang="ts" context="module">
  const files = import.meta.glob('./assets/*.svg', { as: 'raw', eager: true });

  export const icons = Object.entries(files).reduce(
    (acc, [path, file]) => {
      const name = path.replace('./assets/', '').replace('.svg', '');
      acc[name] = file;
      return acc;
    },
    {} as Record<string, string>
  );

  export const isIconVariant = (variant: string | number | undefined): variant is IconOptions => {
    if (!variant) return false;
    return typeof variant === 'string' && Object.keys(icons).includes(variant);
  };

  export type IconOptions =
    | 'audio'
    | 'audio-muted'
    | 'alert'
    | 'alert-hexagon-bold'
    | 'alert-hexagon'
    | 'arrow'
    | 'arrow-left'
    | 'arrow-right'
    | 'bag'
    | 'bag-simple'
    | 'box'
    | 'check'
    | 'check-circle'
    | 'chevron-down'
    | 'chevron-up'
    | 'chevron-left'
    | 'chevron-left-bold'
    | 'chevron-right'
    | 'chevron-right-bold'
    | 'cross'
    | 'close'
    | 'diamond'
    | 'discount'
    | 'elastic'
    | 'exchange'
    | 'expand'
    | 'eye'
    | 'eye-off'
    | 'filter'
    | 'flag'
    | 'gift'
    | 'heart-empty'
    | 'heart-filled'
    | 'info'
    | 'knitting'
    | 'language'
    | 'live'
    | 'logout'
    | 'material'
    | 'menu'
    | 'minus'
    | 'minus-bold'
    | 'mobile'
    | 'padlock'
    | 'pencil'
    | 'phone'
    | 'play'
    | 'pause'
    | 'plus'
    | 'plus-bold'
    | 'priority'
    | 'return'
    | 'ruler'
    | 'sculpt-fit'
    | 'search'
    | 'sewing-thread'
    | 'shop'
    | 'star'
    | 'star-filled'
    | 'star-outline'
    | 'star-half'
    | 'support'
    | 'trash'
    | 'upload'
    | 'user'
    | 'warranty'
    | 'share-favorites'
    | 'sparkles'
    | 'glasses'
    | 'glasses-case'
    | 'sun';

  const sizes = {
    xs: 'w-3.5 h-3.5',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6'
  };
</script>

<script lang="ts">
  import { cn } from '$lib/utils';
  import Glasses from './glasses.svelte';

  export let icon: IconOptions;
  export let size: keyof typeof sizes = 'lg';
  let className: string | undefined = undefined;
  export { className as class };
</script>

{#if icons[icon]}
  <i
    data-icon={icon}
    aria-hidden="true"
    class={cn('inline-block', sizes[size], className)}
    {...$$restProps}
  >
    <!-- eslint-disable-next-line svelte/no-at-html-tags -->
    {@html icons[icon]}
  </i>
{:else if icon == 'glasses'}
  <Glasses class={cn(sizes[size], className)} />
{/if}
